import React, { FC } from 'react';
import { twMerge } from '@shared/utils/twMerge';

type SkeletonLineProps = {
  length?: number;
  className?: string;
};

export const SkeletonLine: FC<SkeletonLineProps> = ({ className, length = 10 }) => {
  return (
    <div
      style={{ width: length }}
      className={twMerge('bg-brightGray h-2 w-[10rem] animate-pulse rounded-[5px]', className)}
    ></div>
  );
};

export const SkeletonCircle: FC<SkeletonLineProps> = ({ className }) => {
  return (
    <div className={twMerge('bg-brightGray h-3 w-3 animate-pulse rounded-md', className)}></div>
  );
};
